import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './index.css';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || "",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// ── PWA install prompt ───────────────────────────────────────────────────────
// Capture the beforeinstallprompt event at module level — BEFORE React renders —
// so it is never missed regardless of when Hero or any other component mounts.
// Components read/clear it via getPwaInstallPrompt() / clearPwaInstallPrompt().
export let _pwaInstallPrompt: any = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  _pwaInstallPrompt = e;
});
window.addEventListener('appinstalled', () => {
  _pwaInstallPrompt = null;
});

/** Returns the deferred BeforeInstallPromptEvent, or null if unavailable. */
export function getPwaInstallPrompt() { return _pwaInstallPrompt; }
/** Clears the stored prompt after use. */
export function clearPwaInstallPrompt() { _pwaInstallPrompt = null; }

// Register the Workbox service worker generated by vite-plugin-pwa.
// autoUpdate: the SW updates silently in the background without a prompt.
if (import.meta.env.PROD) {
	registerSW({ immediate: true });
}

// Note: StrictMode is intentionally omitted in dev to prevent double-invocation
// of Firestore onSnapshot subscriptions and other effects, which causes
// noticeable performance degradation during development.
createRoot(document.getElementById('root')!).render(<App />);
